import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Banner() {
  return (
    <div className="home1_banner_outer position-relative">

      <section className="banner-con position-relative">

        <div className="container">
          <div className="row align-items-center">

            {/* LEFT CONTENT */}
            <div className="col-lg-7">
              <div className="banner_content">

                <motion.h3
                  initial={{ opacity: 0, y: -30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  Gelato Crafted to Melt HeartS
                </motion.h3>

                <motion.h1
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  <span> An Italian Craft </span> FocuSed on Flavor
                </motion.h1>

                <motion.p
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  Made with intention to highlight taste, texture, and freshness.
                </motion.p>

                <motion.div
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.5 }}
                >
                  <Link to="/products" className="all_button">
                    Explore Flavors
                    <i className="fa-solid fa-arrow-right"></i>
                  </Link>
                </motion.div>

              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="col-lg-5">
              <motion.img
                src="/assets/website-images/main-banner.webp"
                alt="banner"
                className="img-fluid"
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.2, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.5 }}
              />
            </div>

          </div>
        </div>

      </section>

    </div>
  );
}

export default Banner;